export const PHONE_MAX_WIDTH = 540;
export const TABLET_MAX_WIDTH = 767;
export const DESKTOP_MAX_WIDTH = 992;
